export default "__VITE_ASSET__$acsmOGz__"